import axios from "axios";
// import qs from "Qs";
import Vue from "vue";
import { Toast } from "vant";
const instance = axios.create();
import ApiUrls from "@/api/apiUrls";

//全局loading
let loading
function urlEncode (obj) {
    let params = Object.keys(obj).map(key => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])
    }).join('&')
    return params
  }
function startLoading() {
    loading = Toast.loading({
        duration: 0, // 持续展示 toast
        // message: Vue.prototype.$t ? Vue.prototype.$t('message.Loading') : '加载中...',
        forbidClick: true,
    });
}
function endLoading() {
    loading.close()
}
//那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}
let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (ever) => {
    for (let p in pending) {
        if (pending[p].u === ever.url + '&' + ever.method) { //当当前请求在数组中存在时执行函数体
            pending[p].f(); //执行取消操作
            pending.splice(p, 1); //把这条记录从数组中移除
        }
    }
}

// 请求拦截
instance.interceptors.request.use(
    (config) => {
        if (config.loading) {
            showFullScreenLoading()
        }
        config.mode = 'cors';
        removePending(config); //在一个ajax发送前执行一下取消操作
        config.cancelToken = new cancelToken((c) => {
            // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
            pending.push({ u: config.url + '&' + config.method, f: c });
        });
        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);
// 响应拦截
instance.interceptors.response.use(function(res){
    console.log(res.config.url,res.config.data,res.data)
    if (res.data.isSuccess == false&&res.data.message=='') {
        // Toast.fail("数据获取失败！")
    }
    tryHideFullScreenLoading()
    removePending(res.config);  //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    return res.data;
},function (error){
        let { data } = error.response;
        console.log(error,data,'error.response.status')        
        switch (error.response.status) {
            case 422:
                break;
            case 400:
                break;
            case 401:
                localStorage.removeItem("onAuthAppCode")
                localStorage.removeItem("token")
                // window.location.href = '/Mobile/'
                break;
            case 404:
                break;
            case 500:
                break;
        }
        return Promise.reject(data);
})

const post = (url, data, config = { loading: false }) => {
    config.headers = {
        "Content-Type": "application/json",
        Authorization:
            "Bearer " + (window.localStorage.getItem("token") || ""),
    };    
    return instance.post(url, data, config);
};

const login = (url, data, config = { loading: false }) => {
    config.headers = {
        "Content-Type": "application/x-www-form-urlencoded",
    };
    data = urlEncode(data);
    return instance.post(url, data, config);
};


const get = (url, params, config = {}) => {
    config.headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (window.sessionStorage.getItem("token") || ""),
    };
    return instance.get(url, {
        params: params,
        ...config,
    });
};

const deleteMethod = (url, config = {}) => {
    return instance({
        url: url,
        method: "delete",
        ...config,
    });
};

export default {
    install(Vue) {
        Object.defineProperties(Vue.prototype, {
            $reqGet: {
                value: get,
            },
            $reqPost: {
                value: post,
            },
            $reqDel: {
                value: deleteMethod,
            },
            $reqLogin: {
                value: login,
            },
        });
    },
};
